import Account from "@/helper/AccountHelper.js";
import ConfigManager from '@/config/ConfigManager.js';
import BzbsApi from '@/core/Http/BzbsApi.js';
import { map } from 'rxjs/operators';
import { CreditCardListModel } from '../model/CreditCardListModel.js'

/**
 * @method apiDeleteCreditCard
 * @method apiGetCreditCard
 * @method apiPostCreditCard
 */
export default {
    apiDeleteCreditCard: function(omiseToken) {
        let token = Account.getToken();
        let params = {
            cardId: omiseToken,
        };
        let url = ConfigManager.getApiModuleUrl() + '/profile/me/delete_card';
        return BzbsApi.connectBzbsDelete(url, token, params).pipe(map((res) => {
            return res.data;
        }));
    },
    apiGetCreditCard: function () {
        let token = Account.getToken();
        let url = ConfigManager.getApiModuleUrl() + '/profile/me/cards';
        return BzbsApi.connectBzbsGet(url, token, null).pipe(map((res) => {
            var creditList = [];
            
            if (res.data.data) {
                for (var i of res.data.data) {
                    var creditr = new CreditCardListModel();
                    creditr.setValueFormApi(i);
                    creditList.push(creditr);
                }
            }
            
            return creditList;
        }));
    },
    apiPostCreditCard: function(omiseToken,isDefault) {
        let token = Account.getToken();
        let params = {
            cardId: omiseToken
        }
        if (isDefault) {
            params.isDefault = true;
        }
        let url = ConfigManager.getApiModuleUrl() + '/profile/me/add_card';
        return BzbsApi.connectBzbsPost(url, token, params).pipe(map((res) => {
            return res.data;
        }));
    },
    apiSetDefaultCreditCard: function(omiseToken) {
        let token = Account.getToken();
        let params = {
            cardId: omiseToken
        }
        let url = ConfigManager.getApiModuleUrl() + '/profile/me/default_card';
        return BzbsApi.connectBzbsPost(url, token, params).pipe(map((res) => {
            return res.data;
        }));
    },
}
